var API_DOMAIN = "https://kingofamarancrackers.zentexus.in/api";

export default API_DOMAIN;
